<template>
  <div>
      <form @submit.prevent="onSubmit">
		<div class="row margin-bottom-15">
		  <div class="col-12 col-sm-12">
			<label
					for="first_name"
					class="col-12">First name : <span class="required">*</span></label>
			<input
					type="first_name"
					name="first_name"
					id="first_name"
					class="col-12 col-sm-12 input-height-35"
					ref="first_name"
					v-validate="'required'"
					v-model="firstName"
          data-vv-as="First name"
          maxlength="180">
			<div v-show="verrors.has('first_name')" class="validate-warning-msg">{{ verrors.first('first_name') }}</div>
		  </div>
		</div>
		<div class="row margin-bottom-15">
		  <div class="col-12 col-sm-12">
			<label
					for="last_name"
					class="col-12">Last name : <span class="required">*</span></label>
			<input
					type="last_name"
					name="last_name"
					id="last_name"
					class="col-12 col-sm-12 input-height-35"
					ref="last_name"
					v-validate="'required'"
					v-model="lastName"
          data-vv-as="Last name"
          maxlength="180">
			<div v-show="verrors.has('last_name')" class="validate-warning-msg">{{ verrors.first('last_name') }}</div>
		  </div>
		</div>
		<div class="row margin-bottom-15">
		  <div class="col-12 col-sm-12">
			<label
					for="phone_number"
					class="col-12">Phone number : </label>
			<input
					type="phone_number"
					name="phone_number"
					id="phone_number"
					class="col-12 col-sm-12 input-height-35"
					ref="phone_number"
					@keyup="phoneValid"
          @blur="phoneValid"
          v-validate="{ rules: { regex: phoneRegex() } }"
					v-model="phoneNumber"
          data-vv-as="Phone number"
          maxlength="14">
			<div v-show="verrors.has('phone_number')" class="validate-warning-msg">Phone number is invalid</div>
		  </div>
		</div>
		<div class="row margin-bottom-15" v-if="action == 'insert'">
		  <div class="col-12 col-sm-12">
			<label
					for="email"
					class="col-12">Email address : <span class="required">*</span></label>
			<input
					type="email_addr"
					name="email"
					id="email_addr"
					class="col-12 col-sm-12 input-height-35"
					ref="email_addr"
					v-validate="'required|email'"
					v-model="emailAddr"
          data-vv-as="Email address"
          maxlength="180">
			<div v-show="verrors.has('email')" class="validate-warning-msg">{{ verrors.first('email') }}</div>
		  </div>
		</div>
    <div class="submit margin-bottom-15">
      <button type="submit" class="btn btn-info btn-md">{{ submit }}</button>
    </div>
      </form>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  name: 'adminform',
  props: ['first_name', 'last_name', 'phone_number', 'email_addr', 'password', 'pw_confirm', 'submit', 'action', 'roles'],
  data() {
    return {
      firstName: this.first_name,
      lastName: this.last_name,
      phoneNumber: this.phone_number,
      emailAddr: this.email_addr,
    }
  },
  methods: {
  onSubmit () {
      this.$validator.validateAll().then((result) => {
        if(!result) {
          return;
        }
        this.createAdmin();
      })
      .catch(() => {

      });
  },
          phoneValid: function(event) {
            var phone = this.phoneNumber;
            this.phoneNumber = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
          },
	        phoneRegex: function() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
          },

  createAdmin() {
      //make axios call to the API
      axios('/users',
        {
          method: 'POST',
          data: {
                 "username": this.emailAddr,
                 "email": this.emailAddr,
                 "roles": [this.roles],
                 "first_name": this.firstName,
                 "last_name": this.lastName,
                 "phone_number": this.phoneNumber,
                 "enabled": true,
                 "signin_count": 0
                 }
        },
      )
      .then(response => {
      		this.$parent.success_message = response.data.successMsg;
      		this.$parent.dismissCountDown = 5;
          this.$parent.backLists();
       })
      .catch(error => {
          const fieldErrors =  [{}];
          // var errMsgObj = error.response.data.message;
          var errMsgObj = JSON.parse(error.response.data.message);
          Object.keys(errMsgObj).map(key => {
             var newFieldErr = {field:key, msg:errMsgObj[key]};
             fieldErrors.push(newFieldErr);
          });
          this.$validator.errors.add(fieldErrors);
       });
  },
  navigate(path) {
    router.push(path);
  },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/admin/researcherform.vue